import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
}), 'Dashboard');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Dashboard.js
// module id = 3043
// module chunks = 2